import { render, staticRenderFns } from "./FerryList.vue?vue&type=template&id=b9b19506"
import script from "@/controllers/custom/ferry/ferry-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/ferry/ferry-list.js?vue&type=script&lang=js&external"
import style0 from "./FerryList.vue?vue&type=style&index=0&id=b9b19506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports